
import React, { useState, useEffect, useRef } from 'react';

import { useSearchParams, useNavigate } from 'react-router-dom';
import Header from './Header';
import Introduction from './Introduction';
import SavePreview from './test';
import Confirmation from './Confirmation';
import InvalidToken from './InvalidToken';
import ExpiredToken from './ExpiredToken';
import getChurchData from '../API/getChurchData';
import updateChurchData from '../API/updateChurchData';
import './ChurchUpdatePage.css';
import * as Dialog from '@radix-ui/react-dialog';



const ChurchUpdatePage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // Extract the token from the query parameter
  const [loading, setLoading] = useState(true);
  const [tokenStatus, setTokenStatus] = useState(null); // 'valid', 'expired', 'invalid'
  const [churchData, setChurchData] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [lastUpdatedBy, setLastUpdatedBy] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const navigate = useNavigate();
  const [validateForm, setValidateForm] = useState(null);
  const savePreviewRef = useRef();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  
  



  useEffect(() => {
    const fetchChurchData = async () => {
      if (!token) {
        setTokenStatus('invalid');
        setLoading(false);
        return;
      }

      try {
        console.log(token);
        const data = await getChurchData(token);
        if (data.success) {
          setChurchData(data.churchData);
          setExpiryDate(data.churchData.tokenExpiresAt); // Set the correct expiration date
          setTokenStatus('valid');
        } else if (data.tokenStatus === 'expired') {
          setLastUpdatedBy(data.lastUpdatedBy);
          setTokenStatus('expired');
        } else {
          setTokenStatus('invalid');
        }
      } catch (error) {
        console.error('Error fetching church data:', error);
        setTokenStatus('invalid');
      } finally {
        setLoading(false);
      }
    };

    fetchChurchData();
  }, [token]);

  const handleSubmit = async () => {
    const errors = savePreviewRef.current.validateAllFields();
    if (errors.length > 0) {
      const errorMessages = errors.map(error => `${error.field}: ${error.message}`);
      setDialogMessage(errorMessages);
      setDialogOpen(true);
      return;
    }
  
    const result = await updateChurchData(token, churchData);
  
    if (result.success) {
      setShowConfirmation(true);
    } else {
      setDialogMessage(result.message);
      setDialogOpen(true);
    }
  };
  
  
  
  
  
  
  
  
  

  const handleGoBack = () => {
    setShowConfirmation(false);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (tokenStatus === 'invalid') {
    return <InvalidToken />;
  }

  if (tokenStatus === 'expired') {
    return <ExpiredToken lastUpdatedBy={lastUpdatedBy} />;
  }

  if (tokenStatus === 'valid') {
    return (
      <div className="church-update-page">
        <Introduction expiryDate={expiryDate} />
        <Header churchName={churchData.name} />
        {!showConfirmation ? (
          <div className="update-content">
<SavePreview
  ref={savePreviewRef}
  data={churchData}
  setData={setChurchData}
/>

            <div className="preview-actions">
              <button onClick={handleSubmit}>Submit</button>
            </div>
          </div>
        ) : (
          <Confirmation message="Your church information has been updated." onGoBack={handleGoBack} />
        )}
<Dialog.Root open={dialogOpen} onOpenChange={setDialogOpen}>
  <Dialog.Portal>
    <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-50" />
    <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg p-6 w-11/12 max-w-md max-h-[85vh] overflow-auto">
      <Dialog.Title className="text-lg font-bold mb-4">Please correct the following errors:</Dialog.Title>
      <Dialog.Description className="mb-6 text-gray-700">
        {Array.isArray(dialogMessage) 
          ? dialogMessage.map((error, index) => (
              <p key={index} className="mb-2">{error}</p>
            ))
          : dialogMessage
        }
      </Dialog.Description>
      <Dialog.Close asChild>
        <button className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-md text-gray-800 transition-colors">
          Close
        </button>
      </Dialog.Close>
    </Dialog.Content>
  </Dialog.Portal>
</Dialog.Root>








      </div>





    );
  }
  

  return null; // In case none of the conditions match
};

export default ChurchUpdatePage;
